import { Component, Input, Output, EventEmitter, SimpleChanges, OnChanges, inject } from '@angular/core';
import { FormControl, FormGroup, FormBuilder } from '@angular/forms';
import { validateNumber } from '../../validators/numeric-input.validator';
import { FormParser } from '../../providers/form-parser.service';
import { validateHexColor } from '../../validators/hex-color.validator';
import { AmbientLightComponent } from 'projects/visualize3d/src/public-api';

type AmbientLightForm = {
  color: FormControl<string>;
  intensity: FormControl<number>;
};

@Component({
  selector: 'app-ambient-light-editor',
  templateUrl: './ambient-light-editor.component.html',
  styleUrls: ['./ambient-light-editor.component.css'],
  standalone: false,
})
export class AmbientLightEditorComponent implements OnChanges {
  private fb = inject(FormBuilder);
  private parser = inject(FormParser);

  @Input() component: AmbientLightComponent;
  @Output() componentChange = new EventEmitter<void>();
  form: FormGroup<AmbientLightForm>;

  constructor() {
    const fb = this.fb;

    this.form = fb.group({
      color: ['', validateHexColor],
      intensity: [0, validateNumber],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.component && changes.component.currentValue) {
      this.form.controls.color.setValue(changes.component.currentValue.color, { emitEvent: false });
      this.form.controls.intensity.setValue(changes.component.currentValue.intensity, { emitEvent: false });
    }
  }

  onSubmit(): void {
    this.component.color = this.form.controls.color.value;
    this.component.intensity = this.parser.parseNumber(this.form.controls.intensity);
    this.componentChange.next();
  }
}
